import { useTranslation } from 'react-i18next';
import { StickyNoteIcon } from 'lucide-react';
import { Button } from '@noor/ui';
import { useModalStore } from '@noor/lib';
import { Can } from '@/entities/access';

/** Opens the create-note modal for an order. */
export function CreateNoteButton({ orderId }: { orderId: string | number }) {
  const { t } = useTranslation('orders');
  const openModal = useModalStore((s) => s.openModal);
  return (
    <Can permission="orders.notes.create">
      <Button
        variant="soft"
        size="sm"
        shape="rounded"
        aria-label={t('action.createNote')}
        title={t('action.createNote')}
        onClick={() => openModal('create-note', { orderId })}
      >
        <StickyNoteIcon className="size-4" />
        {t('action.createNote')}
      </Button>
    </Can>
  );
}
